<template>
  <swiper class="swiper" :options="swiperOption">
    <swiper-slide
      v-for="(slide, index) in bannerhighlights"
      :key="index"
      class="slide-1"
    >
      <div class="slide-container">
        <!-- responsive -->
        <img
          :src="slide.media.banner_responsive.full_url"
          :alt="slide.title"
          v-if="
            slide.banner_type == 'image' &&
            slide.media &&
            slide.media.banner_responsive
          "
          class="bg-image bg-image-responsive"
        />
        <!-- desktop -->
        <img
          :src="slide.media.banner.full_url"
          :alt="slide.title"
          v-if="
            slide.banner_type == 'image' && slide.media && slide.media.banner
          "
          class="bg-image bg-image-desktop"
        />
        <!-- video on desktop -->
        <video
          loop
          muted
          autoplay
          class="w-full h-full object-cover bg-image bg-image-desktop"
          v-if="slide.banner_type == 'video' && isDesktop() === true"
        >
          <source
            :src="
              slide.media &&
              slide.media.banner_video &&
              slide.media.banner_video.full_url
            "
            :type="
              slide.media.banner_video && slide.media.banner_video.mime_type
                ? slide.media.banner_video.mime_type
                : 'video/mp4'
            "
          />
        </video>
        <!-- video on mobile -->
        <img
          :src="slide.media.banner_responsive.full_url"
          :alt="slide.title"
          v-if="
            slide.banner_type == 'video' &&
            isDesktop() === false &&
            slide.media &&
            slide.media.banner_responsive
          "
          class="bg-image bg-image-responsive"
        />
        <div class="shade"></div>
        <div class="wrapper">
          <div class="slide-content" :style="hideButtons ? 'top: 110px !important;' : ''">
            <h1 v-show="slide.title != null">{{ slide.title }}</h1>
            <p v-show="slide.description != null" :style="hideButtons ? 'margin-top: 20px !important;' : ''">{{ slide.description }}</p>
            <!-- target="_blank" ---- should be an option on BO -->
            <a v-if="!hideButtons" v-show="slide.cta_title != null" :href="slide.cta_url">
              <button class="btn-empty">{{ slide.cta_title }}</button>
            </a>
          </div>
        </div>
      </div>
    </swiper-slide>
    <div
      class="swiper-pagination swiper-pagination-white"
      slot="pagination"
      v-show="bannerhighlights.length > 1"
      style="bottom: 70px!important;"
    ></div>
    <div class="wrapper controllers-wrapper">
      <div
        class="swiper-button-prev swiper-button-white"
        slot="button-prev"
        v-show="bannerhighlights.length > 1"
      ></div>
      <div
        class="swiper-button-next swiper-button-white"
        slot="button-next"
        v-show="bannerhighlights.length > 1"
      ></div>
    </div>
  </swiper>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "swiper-example-fade-effect",
  title: "Fade effect",
  props: {
    bannerhighlights: {
      required: true,
    },
    hideButtons: {
      default: false,
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        /* autoplay: {
                        delay: 2500,
                        disableOnInteraction: false
                    }, */
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    isDesktop() {
      return window.innerWidth > 480;
    },
  },
};
</script>

